import { Sb24Executor } from "./Sb24Executor";

export class Sb24AExecutor extends Sb24Executor {
  constructor() {
    super();
    this.fixation = 1;
    this.glassLowerProfile = -0.095;
  }
}
